//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    name: "AQEmptySearch",
    props: {
        tableContent: { type: Boolean, default: false },
        tableEmptyState: { type: Boolean, default: false },
        noDescription: { type: Boolean, default: false },
        noDataBasicTable: { type: Boolean, default: false }
    },
    data() {
        return {
            emptyArray: new Array(10)
        };
    }
};
